var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcCloseBold = function SvgIcCloseBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.134 8.366a1.25 1.25 0 1 0-1.768 1.768l4.95 4.95-4.95 4.95a1.25 1.25 0 1 0 1.768 1.767l4.95-4.95 4.95 4.95a1.25 1.25 0 1 0 1.767-1.768l-4.95-4.95 4.95-4.95a1.25 1.25 0 0 0-1.768-1.767l-4.95 4.95-4.95-4.95Z",
    fill: "current"
  })));
};
export default SvgIcCloseBold;